import React from 'react';
import {
  Button, Form, Tabs,
} from 'antd';
import translations from '../../hooks/translation/translations.json';
import TextInput from '../inputs/TextInput';
import FileInput from '../inputs/FileInput';
import useTranslation from '../../hooks/translation/useTranslation';

function BenefitForm({
  handleSubmit, form, errors,
}) {
  const { trans } = useTranslation();
  const validateFile = (rule, value) => {
    const file = value?.fileList?.[0];

    if (!file) {
      return Promise.resolve();
    }

    const isLt2M = file.size / 1024 / 1024 > 2;
    if (isLt2M) {
      return Promise.reject(translations.ka.max_2mb);
    }

    return Promise.resolve();
  };
  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      form={form}
    >
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: trans('georgian'),
            key: '1',
            children: (
              <TextInput
                label={`${trans('title')}*`}
                name="title_ka"
                errorMessage={errors?.title_ka}
                rules={[{
                  required: true,
                  message: trans('input_necessary'),
                }]}
              />
            ),
          },
          {
            label: trans('english'),
            key: '2',
            children: (
              <TextInput
                label={`${trans('title')}*`}
                name="title_en"
                errorMessage={errors?.title_en}
              />
            ),
          },
          {
            label: trans('russian'),
            key: '3',
            children: (
              <TextInput
                label={`${trans('title')}*`}
                name="title_ru"
                errorMessage={errors?.title_ru}
              />
            ),
          },
        ]}
      />
      <TextInput
        label={`${trans('url')}*`}
        name="url"
        errorMessage={errors?.url}
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
      />
      <FileInput
        form={form}
        name="image"
        label={trans('image')}
        errorMessage={errors?.image}
        accept=".png, .jpg"
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }, { validator: validateFile }]}
      />
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default BenefitForm;
